// src/pages/dashboard/TransactionHistoryPage.js
import React, { useState, useEffect } from 'react';
import { Table, Pagination, Form, InputGroup, Button ,Row, Col} from 'react-bootstrap';
import { FaEye } from 'react-icons/fa'; // For view icon
import MetaTags from '../../components/MetaTags';
import './TransactionHistoryPage.css'; // Create this

// Mock Data
const mockTransactions = [
  { id: 1, role: "1 Girl Required", transactionId: "307003536176", transactionIdLink: "#", status: "Payment Aborted", statusType: 'aborted', paymentMode: "Net Banking", amount: "INR 1.18", date: "24/01/2018 12:44 pm" },
  { id: 2, role: "Required 6 Female Dancers for Music Video", transactionId: "0", transactionIdLink: null, status: "Success", statusType: 'success', paymentMode: "-", amount: "INR 590", date: "17/12/2020 17:24 pm" },
  { id: 3, role: "Lead Male Actor", transactionId: "0", transactionIdLink: null, status: "Success", statusType: 'success', paymentMode: "-", amount: "INR 708", date: "17/07/2023 23:49 pm" },
  // Add more for pagination testing
  { id: 4, role: "Another Role", transactionId: "12345", transactionIdLink: "#", status: "Pending", statusType: 'pending', paymentMode: "Credit Card", amount: "INR 250", date: "10/05/2024 10:00 am" },
  { id: 5, role: "Voice Over Artist", transactionId: "67890", transactionIdLink: null, status: "Success", statusType: 'success', paymentMode: "UPI", amount: "INR 100", date: "11/05/2024 11:30 am" },
];

const TransactionHistoryPage = () => {
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10); // From "Show X entries"
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    setLoading(true);
    // Simulate API call
    setTimeout(() => {
      setTransactions(mockTransactions);
      setLoading(false);
    }, 500);
  }, []);

  const filteredTransactions = transactions.filter(t =>
    Object.values(t).some(val =>
      String(val).toLowerCase().includes(searchTerm.toLowerCase())
    )
  );

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredTransactions.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredTransactions.length / itemsPerPage);

  const handlePageChange = (pageNumber) => setCurrentPage(pageNumber);

  const renderStatus = (status, statusType) => {
    let icon = null;
    let colorClass = '';
    if (statusType === 'success') {
        // icon = <FaCheckCircle className="text-success me-1" />; // Example
        colorClass = 'status-success';
    } else if (statusType === 'aborted') {
        // icon = <FaTimesCircle className="text-danger me-1" />;
        colorClass = 'status-aborted';
    } else if (statusType === 'pending') {
        // icon = <FaHourglassHalf className="text-warning me-1" />;
        colorClass = 'status-pending';
    }
    // The image shows a specific "VIEW" icon for success, let's use FaEye for now
    return (
        <span className={`status-badge ${colorClass}`}>
            {statusType === 'success' && <FaEye className="me-1 status-icon-view" />} 
            {status}
        </span>
    );
  };

  return (
    <>
      <MetaTags title="Transaction History - Dashboard" />
      <div className="page-header mb-3">
        <h5 className="text-uppercase fw-bold color-b7343a">Transaction History</h5>
      </div>

      <div className="controls-bar d-flex justify-content-between align-items-center mb-3">
        <Form.Group as={Row} className="align-items-center g-2">
          <Form.Label column sm="auto" className="mb-0 small">Show</Form.Label>
          <Col sm="auto">
            <Form.Select size="sm" value={itemsPerPage} onChange={e => setItemsPerPage(Number(e.target.value))}>
              <option value={10}>10</option>
              <option value={25}>25</option>
              <option value={50}>50</option>
            </Form.Select>
          </Col>
          <Form.Label column sm="auto" className="mb-0 ms-1 small">entries</Form.Label>
        </Form.Group>
        <InputGroup size="sm" style={{ maxWidth: '250px' }}>
          <Form.Control
            type="search"
            placeholder="Search..."
            value={searchTerm}
            onChange={e => setSearchTerm(e.target.value)}
          />
          {/* <Button variant="outline-secondary"><FaSearch/></Button> */}
        </InputGroup>
      </div>

      {loading ? (
        <p>Loading transactions...</p>
      ) : (
        <>
          <Table striped bordered hover responsive size="sm" className="transaction-table">
            <thead>
              <tr>
                <th>#</th>
                <th>Role</th>
                <th>Transaction ID</th>
                <th>Status</th>
                <th>Payment Mode</th>
                <th>Amount</th>
                <th>Date</th>
              </tr>
            </thead>
            <tbody>
              {currentItems.length > 0 ? currentItems.map((t, index) => (
                <tr key={t.id}>
                  <td>{indexOfFirstItem + index + 1}</td>
                  <td>{t.role}</td>
                  <td>
                    {t.transactionIdLink ? (
                      <a href={t.transactionIdLink} className="transaction-id-link">{t.transactionId}</a>
                    ) : (
                      t.transactionId
                    )}
                  </td>
                  <td>{renderStatus(t.status, t.statusType)}</td>
                  <td>{t.paymentMode}</td>
                  <td>{t.amount}</td>
                  <td>{t.date}</td>
                </tr>
              )) : (
                <tr><td colSpan="7" className="text-center">No transactions found.</td></tr>
              )}
            </tbody>
          </Table>

          {totalPages > 1 && (
            <div className="d-flex justify-content-between align-items-center mt-3">
                <span className="small text-muted">
                    Showing {indexOfFirstItem + 1} to {Math.min(indexOfLastItem, filteredTransactions.length)} of {filteredTransactions.length} entries
                </span>
                <Pagination size="sm">
                <Pagination.Prev onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} />
                {/* Simplified Pagination - for more items, generate dynamically */}
                {[...Array(totalPages).keys()].map(number => (
                    // Only show a few page numbers around current for large totalPages
                    (number + 1 === currentPage || 
                     number + 1 === currentPage - 1 || 
                     number + 1 === currentPage + 1 ||
                     totalPages <= 5 || /* Show all if few pages */
                     (currentPage <= 2 && number < 3) || /* Start pages */
                     (currentPage >= totalPages -1 && number >= totalPages - 3) /* End pages */
                     ) && (
                    <Pagination.Item key={number + 1} active={number + 1 === currentPage} onClick={() => handlePageChange(number + 1)}>
                        {number + 1}
                    </Pagination.Item>
                    )
                ))}
                 <Pagination.Next onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages} />
                </Pagination>
            </div>
          )}
        </>
      )}
    </>
  );
};

export default TransactionHistoryPage;